import { gql } from '@apollo/client'

import { GIFT_CARD_FRAGMENT } from '../../fragments/customer/giftCard'

export const GET_CURRENT_CUSTOMER_GIFT_CARDS = gql`
  query CurrentCustomerGiftCards {
    currentCustomer {
      id
      orderGiftCards {
        ...GiftCardFields
      }
    }
  }
  ${GIFT_CARD_FRAGMENT}
`
